import React from 'react';
import { ArrowRight, Cloud } from 'lucide-react';

const FinalCta = ({ user, onLoginClick, onDashboardClick }) => (
  <div className="lp-section lp-final">
    <div className="lp-container">
      <div className="lp-final-card">
        <div className="lp-final-copy">
          <span className="lp-badge">Ready when you are</span>
          <h2>Focus on building. We&apos;ll handle the rest.</h2>
          <p>
            Deploy Docker, Git, and ZIP workloads with routing, logs, and team controls —
            without babysitting servers.
          </p>
          <div className="lp-final-actions">
            {user ? (
              <button type="button" className="lp-btn lp-btn-primary lp-btn-lg" onClick={onDashboardClick}>
                Open dashboard
                <ArrowRight size={18} />
              </button>
            ) : (
              <button type="button" className="lp-btn lp-btn-primary lp-btn-lg" onClick={() => onLoginClick('hobby', true)}>
                Start free
                <ArrowRight size={18} />
              </button>
            )}
            <button type="button" className="lp-btn lp-btn-secondary lp-btn-lg" onClick={() => onLoginClick('hobby', false)}>
              Sign in
            </button>
          </div>
        </div>

        <div className="lp-final-visual" aria-hidden="true">
          <div className="lp-stack-card">
            <span>Build</span>
            <div className="track"><i style={{ width: '92%' }} /></div>
          </div>
          <div className="lp-stack-card">
            <span>Deploy</span>
            <div className="track"><i style={{ width: '78%' }} /></div>
          </div>
          <div className="lp-stack-card">
            <span>Monitor</span>
            <div className="track"><i style={{ width: '64%' }} /></div>
          </div>
          <div className="lp-scale-card">
            <Cloud size={18} />
            <strong>Scale effortlessly</strong>
            <span>Auto resources when traffic spikes</span>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default FinalCta;
